import { I18N } from "aurelia-i18n";
import KeyDownEvent = JQuery.KeyDownEvent;
import { MobileHelper } from "../../../../helpers/mobile-helper";
import { autoinject, transient } from "aurelia-dependency-injection";
import { Claims } from "../../../../constants/authentication/claims";
import { CustomGridPageBase } from "../../common/custom-grid-page.base";
import { BindingEngine, computedFrom, observable } from "aurelia-binding";
import { SubtasksService } from "../../../../services/subtasks/subtasks.service";
import { DialogServiceConstants } from "../../../../constants/basics/dialog.constants";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { UserClaimsService } from "../../../../services/authentication/user-claims.service";
import { RightShipDialogServiceConstants } from "../../../../constants/basics/rightship-dialog.constants";
import { GenericConfirmationDialogModel } from "../../../../models/basics/generic-confirmation-dialog-model";
import { DataGridColumn, DataType, QueryFilter, SourceType } from "../../../../models/queries/queries.models";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";

@autoinject()
@transient()
export class RfiTemplates extends CustomGridPageBase {

    public appliedFilter: string;
    public isFiltered: boolean = false;
    public initialFilters: QueryFilter[];
    private odataUrl = "odata/SubtaskTypes";
    public selectedFilter: { title: string, clear: () => void, apply: () => void };
    public isMobileFilterOpen: boolean = false;
    public mobileSelectedfilters : any[] = []
    public isColumnFiltering: boolean = false;

    canAddSubtaskTypes: boolean = false;
    canRemoveSubtaskTypes: boolean = false;

    public yesNoOptions : any[] = [{id: 0, name: "Yes"}, {id: 1, name: "No"}]

    constructor(i18N: I18N, 
        userClaimsService: UserClaimsService,
        protected bindingEngine: BindingEngine,
        private dialogService: DialogClientService,
        private subtasksService: SubtasksService,
        private notificationClientService: NotificationClientService,
        private dialogClient: DialogClientService ) {
            super(i18N, "RFITemplates", bindingEngine);
            this.canAddSubtaskTypes = userClaimsService.hasPermission(Claims.CanAddSubtaskTypes);
            this.canRemoveSubtaskTypes = userClaimsService.hasPermission(Claims.CanRemoveSubtaskTypes);
            this.initialSorting = this.getSorting();
    }

    public getSorting() {
        let columns: DataGridColumn[] = [];
        columns =  []

        return columns;
    }

    activate() {
        this.columns = this.getColumns();
        this.itemSource = this.getItemSource([])
    }

    getColumns(): DataGridColumn[] {
        return  [
            {
                dataType: DataType.CustomTemplate,
                value: `<check-box checked.bind="getRowItem() && getRowItem().isSelected"
                        changed.delegate="getDataGrid().selectRowInMultipleSelection(getRowItem())">
                    </check-box>`,
                name: "select",
                title: MobileHelper.isMobileDevice() ? "" : `<check-box class="check-box-select-all" checked.two-way="toggleAll"></check-box>`,
                parameter: {
                    item: null
                },
                instancePerRow: true,
                sortOrder: 0,
                columnOrder: -2,
                width: "38px",
                isHidden: false,
                isSortable: false,
                getCellClass: () => {
                    return "selector-checkbox";
                }
            },
            {
                dataType: DataType.CustomTemplate,
                name: "name",
                title: "Name",
                instancePerRow:  true,
                sortOrder:  1,
                columnOrder:  -1,
                isHidden:  false,
                isSortable: true,
                value: (item, row, column, dataGridVM) => {
                    if (item && dataGridVM) {
                        this.dialogClient.show(RightShipDialogServiceConstants.URLs.AddSubtaskTypeDialog, {
                            dataGrid: dataGridVM,
                            subtaskTypeId: item.id
                        }, true, false, false, 'right');
                    }
                    return '<div class="column"><a click.trigger="getDataGrid().handleClickOnButton($event,getRowItem(),getRowItem().columnKeys[`name`].column)" class="link" href="#">${item.name}</a></div>';
                },
                parameter: {
                    item: null
                }
            }, 
            {
                name: "isActive",
                title: "Is Active",
                dataType: DataType.Boolean,
                isHidden: false,
                isSortable: true,
                isGrouping: false,
                sortOrder: 2, 
                columnOrder: 2,
                isDynamicProperty: false,
                isCollection: false
            },
            {
                name: "isDefault",
                title: "Is Default",
                dataType: DataType.Boolean,
                isHidden: false,
                isSortable: true,
                isGrouping: false,
                sortOrder: 3, 
                columnOrder: 3,
                isDynamicProperty: false,
                isCollection: false
            },
            {
                name:  "isCloseConversation",
                title: "Is Close Conversation",
                dataType: DataType.Boolean,
                isHidden: false,
                isSortable: true,
                isGrouping: false,
                sortOrder: 4,
                columnOrder: 4,
                isDynamicProperty: false,
                isCollection: false
            },
            {
                name:  "usedForConsolidationEmail",
                title: "Used for Consolidation Email",
                dataType: DataType.Boolean,
                isHidden: false,
                isSortable: true,
                isGrouping: false,
                sortOrder: 5,
                columnOrder: 5,
                isDynamicProperty: false,
                isCollection: false
            },
            {
                name:  "excludeFromHome",
                title: "Exclude from Home",
                dataType: DataType.Boolean,
                isHidden: false,
                isSortable: true,
                isGrouping: false,
                sortOrder: 5,
                columnOrder: 5,
                isDynamicProperty: false,
                isCollection: false
            },
            {
                name:  "rfiTemplateCategory",
                title: "RFI Template Category",
                dataType: DataType.Default,
                isHidden: false,
                isSortable: true,
                isGrouping: false,
                sortOrder: 6,
                columnOrder: 6,
                isDynamicProperty: false,
                isCollection: false
            }
        ];
    }

    private getItemSource(filters) {
        this.initialFilters = filters;
        return {
            sourceType: SourceType.ODataUrl,
            source: this.odataUrl,
            columns: this.columns,
            initialSorting: this.initialSorting,
            initialFilters: filters,
        };
    }

    closeAllFilters() {
        this.showActiveFilter = false;
        this.showDefaultFilter = false;
        this.showICCFilter = false;
        this.showUCEFilter = false;
        this.showERHFilter = false;
        this.showRTCFilter = false;
    }

    private setItemSource() { 
        const currentFilters: QueryFilter[] = []; 

        if (this.appliedFilter) {
            currentFilters.push(QueryFilter.getQuery("name", this.appliedFilter, "contains({0}, '{1}')", DataType.Default,false,false,null,false,true))
        }

        // Active filter
        if(this.activeFilterActive) {
            if(this.selectedActive.length == 1) {
                const isActive = this.selectedActive[0] == this.activeOptions[0].id
                currentFilters.push(QueryFilter.getQuery('isActive', isActive, "eq",DataType.Boolean,true))
            }
        }    

        // Default filter
        if(this.defaultFilterActive) {
            if(this.selectedDefault.length == 1) {
                const isDefault = this.selectedDefault[0] == this.defaultOptions[0].id
                currentFilters.push(QueryFilter.getQuery('isDefault', isDefault, "eq",DataType.Boolean,true))
            }
        }

        // ICC filter
        if(this.iCCFilterActive) {
            if(this.selectedICC.length == 1) {
                const iCC = this.selectedICC[0] == this.yesNoOptions[0].id
                currentFilters.push(QueryFilter.getQuery('isCloseConversation', iCC, "eq",DataType.Boolean,true))
            }
        }

        // UCE filter
        if(this.uCEFilterActive) {
            if(this.selectedUCE.length == 1) {
                const uCE = this.selectedUCE[0] == this.yesNoOptions[0].id
                currentFilters.push(QueryFilter.getQuery('usedForConsolidationEmail', uCE, "eq",DataType.Boolean,true))
            }
        }

        // ERH filter
        if(this.eRHFilterActive) {
            if(this.selectedERH.length == 1) {
                const eRH = this.selectedERH[0] == this.yesNoOptions[0].id
                currentFilters.push(QueryFilter.getQuery('excludeFromHome', eRH, "eq",DataType.Boolean,true))
            }
        }

        // RTC filter
        if(this.rTCFilterActive) {
            const rTCFilter: QueryFilter = {
                filterOperator: {
                    translatedSymbol: "{0} in ({1})",
                    friendlyName: "in",
                    requiresFilterValue: true,
                    requiresInterpolation: true
                },
                filterProperty: {
                    name: "rfiTemplateCategoryId",
                    isDynamicProperty: false,
                    type: DataType.Lookup,
                    lookupMappedToProperty: "RS_RfiTemplateCategories",
                    isNullable: true,
                },
                filterValue: this.selectedRTC || [],
                isAnd: true,
                skipOnNullOrEmpty: true,
            };
            currentFilters.push(rTCFilter) 
        }

        this.itemSource = this.getItemSource(currentFilters);
        this.isFiltered = currentFilters.length > 0 || this.isColumnFiltering === true;
    }

    public get isSubFilterOpen(): boolean {
        return this.showActiveFilter || this.showDefaultFilter || this.showICCFilter || this.showUCEFilter  || this.showERHFilter || this.showRTCFilter;
    }

   @observable()
   public filter: string;

   filterKeyDown($event) {
        const e: KeyDownEvent = $event.detail;

        if (e.key == "Enter") {
            this.appliedFilter = this.filter;
            this.setItemSource();
        }
    }
    
    filterChanged() {
        if ((this.filter && this.filter.length >= 5) || this.filter == "") {
            this.appliedFilter = this.filter;
            this.setItemSource();
        }
    }

    // #region Active filter
    public selectedActive : any[] = []
    public activeOptions : any[] = [{id: 0, name: "Active"}, {id: 1, name: "Inactive"}]
    public showActiveFilter: boolean;
    public activeIsApplied: boolean;
    toggleActiveFilter() {
        if(!this.showActiveFilter) {
            this.closeAllFilters();
        }
        this.showActiveFilter = !this.showActiveFilter;
    }
    public activeSetSelectedFilter() {
        this.selectedFilter = {
            title: "Active",
            clear: () => {
                this.clearActiveFilter();
            },
            apply: () => {
                this.showActiveFilter = false;
            }
        }
    }
    public clearActiveFilter(setSource = true) {
        this.selectedActive = []
        this.activeIsApplied = false;

        if(setSource) {
            this.setItemSource();
        }
    }
    public applyActiveFilter(event) { 
        this.selectedActive = event.items.filter(x => x.isSelected).map(x => x.id)
        this.setItemSource();
        this.showActiveFilter = false;
    }
    @computedFrom("selectedActive") 
    public get activeFilterActive() {
        return this.selectedActive && this.selectedActive.length > 0
    }
    //#endregion

    // #region Default filter
    public selectedDefault : any[] = []
    public defaultOptions : any[] = [{id: 0, name: "Default"}, {id: 1, name: "Not Default"}]
    public showDefaultFilter: boolean;
    public defaultIsApplied: boolean;
    toggleDefaultFilter() {
        if(!this.showDefaultFilter) {
            this.closeAllFilters();
        }
        this.showDefaultFilter = !this.showDefaultFilter;
    }
    public defaultSetSelectedFilter() {
        this.selectedFilter = {
            title: "Default",
            clear: () => {
                this.clearDefaultFilter();
            },
            apply: () => {
                this.showDefaultFilter = false;
            }
        }
    }
    public clearDefaultFilter(setSource = true) {
        this.selectedDefault = []
        this.defaultIsApplied = false;

        if(setSource) {
            this.setItemSource();
        }
    }
    public applyDefaultFilter(event) { 
        this.selectedDefault = event.items.filter(x => x.isSelected).map(x => x.id)
        this.setItemSource();
        this.showDefaultFilter = false;
    }
    @computedFrom("selectedDefault") 
    public get defaultFilterActive() {
        return this.selectedDefault && this.selectedDefault.length > 0
    }
    //#endregion

    // #region ICC filter
    public selectedICC : any[] = []
    public showICCFilter: boolean;
    public iCCIsApplied: boolean;
    toggleICCFilter() {
        if(!this.showICCFilter) {
            this.closeAllFilters();
        }
        this.showICCFilter = !this.showICCFilter;
    }
    public iCCSetSelectedFilter() {
        this.selectedFilter = {
            title: "ICC",
            clear: () => {
                this.clearICCFilter();
            },
            apply: () => {
                this.showICCFilter = false;
            }
        }
    }
    public clearICCFilter(setSource = true) {
        this.selectedICC = []
        this.iCCIsApplied = false;

        if(setSource) {
            this.setItemSource();
        }
    }
    public applyICCFilter(event) { 
        this.selectedICC = event.items.filter(x => x.isSelected).map(x => x.id)
        this.setItemSource();
        this.showICCFilter = false;
    }
    @computedFrom("selectedICC") 
    public get iCCFilterActive() {
        return this.selectedICC && this.selectedICC.length > 0
    }
    //#endregion

    // #region UCE filter
    public selectedUCE : any[] = []
    public showUCEFilter: boolean;
    public uCEIsApplied: boolean;

    public toggleUCEFilter() {
        if(!this.showUCEFilter) {
            this.closeAllFilters();
        }
        this.showUCEFilter = !this.showUCEFilter;
    }

    public uCESetSelectedFilter() {
        this.selectedFilter = {
            title: "UCE",
            clear: () => {
                this.clearUCEFilter();
            },
            apply: () => {
                this.showUCEFilter = false;
            }
        }
    }
    public clearUCEFilter(setSource = true) {
        this.selectedUCE = []
        this.uCEIsApplied = false;

        if(setSource) {
            this.setItemSource();
        }
    }
    public applyUCEFilter(event) { 
        this.selectedUCE = event.items.filter(x => x.isSelected).map(x => x.id)
        this.setItemSource();
        this.showUCEFilter = false;
    }
    @computedFrom("selectedUCE") 
    public get uCEFilterActive() {
        return this.selectedUCE && this.selectedUCE.length > 0
    }
    //#endregion
    // #region UCE filter
    public selectedERH : any[] = []
    public showERHFilter: boolean;
    public eRHIsApplied: boolean;

    public toggleERHFilter() {
        if(!this.showERHFilter) {
            this.closeAllFilters();
        }
        this.showERHFilter = !this.showERHFilter;
    }

    public eRHSetSelectedFilter() {
        this.selectedFilter = {
            title: "ERH",
            clear: () => {
                this.clearERHFilter();
            },
            apply: () => {
                this.showERHFilter = false;
            }
        }
    }
    public clearERHFilter(setSource = true) {
        this.selectedERH = []
        this.eRHIsApplied = false;

        if(setSource) {
            this.setItemSource();
        }
    }
    public applyERHFilter(event) { 
        this.selectedERH = event.items.filter(x => x.isSelected).map(x => x.id)
        this.setItemSource();
        this.showERHFilter = false;
    }
    @computedFrom("selectedERH") 
    public get eRHFilterActive() {
        return this.selectedERH && this.selectedERH.length > 0
    }
    //#endregion

    // #region RTC filter
    public selectedRTC : any[] = []
    public showRTCFilter: boolean;
    public rTCIsApplied: boolean;

    public toggleRTCFilter() {
        if(!this.showRTCFilter) {
            this.closeAllFilters();
        }
        this.showRTCFilter = !this.showRTCFilter;
    }

    public rTCSetSelectedFilter() {
        this.selectedFilter = {
            title: "RTC",
            clear: () => {
                this.clearRTCFilter();
            },
            apply: () => {
                this.showRTCFilter = false;
            }
        }
    }
    public clearRTCFilter(setSource = true) {
        this.selectedRTC = []
        this.rTCIsApplied = false;

        if(setSource) {
            this.setItemSource();
        }
    }
    public applyRTCFilter(event) { 
        this.selectedRTC = event.items.filter(x => x.isSelected).map(x => x.id)
        this.setItemSource();
        this.showRTCFilter = false;
    }
    @computedFrom("selectedRTC") 
    public get rTCFilterActive() {
        return this.selectedRTC && this.selectedRTC.length > 0
    }
    //#endregion

    toggleMobileFilterDialog() {
        if (!this.isSubFilterOpen) {
            this.isMobileFilterOpen = !this.isMobileFilterOpen;
        }
    }

    public mobileApplyAllFilters(toggleDialog: boolean = true) {
        if(toggleDialog)
            this.toggleMobileFilterDialog();
            
        this.mobileSelectedfilters.forEach(x => {
            x.apply();
        })
        //Refresh itemSource irrelevant of number of mobileSelectedFilters. Users may unselect all filters (resulting in no selected filters)
        this.setItemSource();
        this.mobileSelectedfilters = []
    }

    hideMobileFilters() {
        this.isMobileFilterOpen = false;    
    }
    public mobileAddSelectedFilter() {
        if (this.selectedFilter) {
            this.mobileSelectedfilters.push(this.selectedFilter)
            this.selectedFilter = null;
        }
    }

    public clearAllFilters() { 
        if(this.dataGridVM)
        {   
            this.dataGridVM.clearSorting();
            this.isColumnFiltering = false;
        }
        this.clearActiveFilter(false);        
        this.clearDefaultFilter(false);        
        this.clearICCFilter(false);        
        this.clearUCEFilter(false);        
        this.clearERHFilter(false);        
        this.clearRTCFilter(false);

        this.setItemSource();
    }

    addSubtaskType() {
        this.dialogService.show(RightShipDialogServiceConstants.URLs.AddSubtaskTypeDialog, {
            dataGrid: this.dataGridVM,
            subtaskTypeId: null
        }, true, false, false, 'right');
    }

    showDeleteDialog() {
        if ((!this.dataGridVM.toggleAll && this.dataGridVM.getSpecificIds().length == 0)) {
            this.notificationClientService.show(this.i18N.tr('no-items-selected-text'), "", NotificationType.Warning);
            return;
        }
        const model = new GenericConfirmationDialogModel();
        model.confirm = this.i18N.tr('delete-text');
        model.cancel = this.i18N.tr('cancel-text');
        model.messages.push(this.i18N.tr('are-you-sure-you-want-to-delete'));
        model.title = this.i18N.tr('confirm-delete-text');
        model.onConfirm = () => this.removeSubtaskTypes();
        this.dialogService.show(DialogServiceConstants.URLs.GenericConfirmationDialog, model, true, false, false);
    }

    removeSubtaskTypes() {
        return new Promise<void>((resolve, reject) => {
            const selectedSubtaskTypeIds = this.dataGridVM.getSelectedRowsCollection().map(x => x.item.subtaskTypeId);
            this.subtasksService.deleteSubtaksTypes(selectedSubtaskTypeIds).then(() => {
                this.dataGridVM.reloadData();
                resolve();
            }).catch(() => {
                reject();
            });
        });
    }

    sortByMobile(column: DataGridColumn) {
        this.dataGridVM.sortingTriggered(column);
        this.isColumnFiltering = this.dataGridVM.visibleColumns.some(item => item.isAscending === true || item.isAscending === false);
        this.setItemSource();
    }

    sortClass(column: DataGridColumn) {
        if (column.isAscending) {
            return "Ascending"
        }
        else if (column.isAscending == false) {
            return "Descending"
        }
        else {
            return "";
        }
    }
}